export default __webpack_public_path__ + "static/media/halloween3.563f89a2.png";